module.exports = __webpack_public_path__ + "site-21.jpg?b4cf00b325f8775e52a96234e4924040";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/portfolio/site-21.jpg
 ** module id = 127
 ** module chunks = 0
 **/